module.exports = __webpack_public_path__ + "d94b04d1dba84692db6b6a5bac2f5ccf.svg";